import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { CookieConsentService } from '@core/services/cookie-consent.service';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class OneTrustInitService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private cookieConsent: CookieConsentService
  ) {}

  load(): void {
    const autoBlockScript = environment.cookieConsent.autoBlockScript;
    const mainScript = environment.cookieConsent.scriptUrl;

    this.cookieConsent.install();

    if (this.scriptExists(mainScript)) {
      return;
    }

    if (autoBlockScript) {
      this.document.head.appendChild(
        this.getLinkNode(autoBlockScript, true, false)
      );
    }
    this.document.head.appendChild(this.getLinkNode(mainScript, true, true));
  }

  getLinkNode(src: string, async?: boolean, addDomain?: boolean) {
    const node = this.document.createElement('script');
    node.async = async || false;
    node.type = 'text/javascript';
    node.setAttribute('charset', 'UTF-8');
    addDomain &&
      node.setAttribute(
        'data-domain-script',
        environment.cookieConsent.dataDomainScript
      );
    node.src = src;

    return node;
  }

  private scriptExists(url: string): boolean {
    const scripts = this.document.getElementsByTagName('script');

    for (let i = scripts.length; i--; ) {
      if (scripts[i].src == url) {
        return true;
      }
    }

    return false;
  }
}
